// // useRoutes.js
// import { useTranslation } from "react-i18next";
// import routes from "routes";
// const useRoutes = () => {
//   const { t } = useTranslation();

//   // Map through the routes array and localize the names
//   const localizedRoutes = routes?.map((route) => ({
//     ...route,
//     name: t(route.name), // Assuming route names are lowercase and match keys in your localization files
    
//   }));

//   return localizedRoutes;
// };

// export default useRoutes;
// useRoutes.js
import { useTranslation } from "react-i18next";
import routes from "routes";

const localizeRouteNames = (route, t) => {
  // Localize the name of the current route
  const localizedRoute = {
    ...route,
    name: t(route.name), // Assuming route names are lowercase and match keys in your localization files
  };

  // If the route has child routes, localize their names recursively
  if (localizedRoute.children) {
    localizedRoute.children = localizedRoute.children.map((childRoute) =>
      localizeRouteNames(childRoute, t)
    );
  }

  return localizedRoute;
};

const useRoutes = () => {
  const { t } = useTranslation();

  // Localize the names of all routes and their children
  const localizedRoutes = routes?.map((route) =>
    localizeRouteNames(route, t)
  );

  return localizedRoutes;
};

export default useRoutes;
